import React from 'react'
import ArrowTxtBtn from '../../../../../img/icon-txt-btn-arrow.svg';

function NavRegisterButton({customClass}) {
    // Component level JSX return statement ******************************************************
    return (
        <a href="#dates" className={`nav-reg-button ${customClass}`} >Register <ArrowTxtBtn/></a>
    )
}
export default NavRegisterButton;